import React, { useEffect, useState } from "react";
import { Button, Form, Popover, Row, Space, Spin, Table } from "antd";
import { ColumnPopoverDisplay, InputFields } from "components/common";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import dayjs from "dayjs";
import {
  payService,
  employeeService,
  medicalExaminationService,
  accoutingFinancial,
} from "api";
import Notification from "components/common/notification/notification";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { formatToCurrencyType } from "helper/common";
import { ColumnProps } from "../../../types/models";
import {
  gioiTinhOptions,
  loaiKCBOptions,
} from "assets/constants/select-catagory-options";
import ObjectTypeColumn from "components/common/ColumnColors/KCBTypeColumn/ObjectTypeColumn";
import { field } from "pages/Pay/PushDataXML/PushDataXML.config";
const {
  INPUT,
  SELECT,
  DATE,
  CODE,
  COMBO_BOX,
  AUTO_COMPLETE,
  DATE_DISABLE_NO_DAY,
} = FIELD_TYPE;

const TheKham = () => {
  const columnsTable: any = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: "60px",
      render: (text, record, index) => index + 1,
      align: "center",
      show:true,
    },
    {
      title: "Mã thẻ",
      dataIndex: "maLoaiThe",
      key: "maLoaiThe",
      // width: '100px',
      align: "center",
      show: true,
    },
    {
      title: "Tên thẻ",
      dataIndex: "tenLoaiThe",
      key: "tenLoaiThe",
      // width: '8%',
      align: "left",
      show: true,
    },
    {
      title: "Số lượt bán thẻ",
      dataIndex: "soLuotBan",
      key: "soLuotBan",
      // width: '100px',
      align: "right",
      show: true,
    },
    {
      title: "Số lượt khám theo thẻ",
      dataIndex: "soLuotKham",
      key: "soLuotKham",
      // width: '100px',
      align: "right",
      show: true,
    },
  ];
  const dataField: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã thẻ",
      name: "maLoaiThe",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      rules: [
        {
          max: 10,
          message: "Định dạng mã thẻ không đúng",
        },
      ],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: INPUT,
      label: "Tên thẻ",
      name: "tenLoaiThe",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      rules: [
        {
          max: 100,
          message: "Định dạng tên bệnh nhân không đúng",
        },
      ],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: AUTO_COMPLETE,
      label: "Người bán thẻ",
      name: "nguoiBanThe",
      // mode: "multiple",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: DATE,
      disableDate: false,
      needConfirm:false,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      label: "Từ ngày",
      name: "start",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    {
      type: DATE,
      disableDate: false,
      needConfirm:false,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      label: "Đến ngày",
      name: "end",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    // {
    //   type: SELECT,
    //   label: "Loại dịch vụ",
    //   name: "type",
    //   placeholder: "Chọn",
    //   options: [
    //     { value: 0, label: "Ngoại trú" },
    //     { value: 1, label: "Nội trú" },
    //   ],
    //   css: {
    //     xl: 8,
    //     lg: 8,
    //     md: 8,
    //     sm: 12,
    //     xs: 24,
    //   },
    //   labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    //   wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    // },
  ];
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(columnsTable);
  const [fields, setFields] = useState(dataField);
  const [form] = Form.useForm();
  const [totalPage, setTotalPage] = useState();
   const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [tab, setTab] = useState();
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
 // const [previousPage, setPreviousPage] = useState(params.page);
  useEffect(() => {
    getListEmployee();
  }, []);
  columns.map((e) => {
    if (e.key == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const getListEmployee = async () => {
    try {
      const response =
        (await employeeService.searchEmployee({
          page: 1,
          limit: 1000,
        })) || [];
      fields.find(e => e.name == "nguoiBanThe").options = response.items.map(
        e => {
          return {value: e.hoTen, label: e.hoTen};
        }
      );
      setFields([...fields]);
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  useEffect(() => {
    const todayStartWithTime = dayjs()
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0);
    const todayEndWithTime = dayjs()
      .set("hour", 23)
      .set("minute", 59)
      .set("second", 59);
    form.setFieldValue("start", todayStartWithTime);
    form.setFieldValue("end", todayEndWithTime);
  }, []);
  // useEffect(() => {
  //   if (previousPage !== params.page) {
  //     handleOnFinish();
  //     setPreviousPage(params.page);
  //   }
  // }, [params.page]);
  const handleOnFinish = () => {
    const data = form.getFieldsValue();
    const paramss = {page:1,limit: 100}
    const dataParams = {
      ...data,
      ...paramss,
      start: dayjs(data.start).format(FORMAT_TIME.dateTimeH),
      end: dayjs(data.end).format(FORMAT_TIME.dateTimeH),
    };
    if (
      !dataParams.start ||
      !dataParams.end ||
      dataParams.start == "Invalid Date" ||
      dataParams.end == "Invalid Date"
    ) {
      Notification("warning", "Vui lòng chọn ngày");
      return;
    }
    getData(dataParams);
  };
  const getData = async (data) => {
    setLoading(true);
    try {
      const response = await accoutingFinancial
        .getListTheKham(data)
        .then((res) => {
          setData(res.data.data);
          setTotalPage(res.data.total);
          setLoading(false);
          Notification("success", "Lấy thông tin báo cáo thành công");
        });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy thông tin báo cáo");
    }
  };

  const addClass = (arr, idx) => {
    if (idx + 1 == arr.length) {
      return "";
    } else {
      return "border-bottom-cell";
    }
  };
  const handelOnExport = async () => {
    setLoadingPage(true);
    const data = form.getFieldsValue();
    const dataParams = {
      ...data,
      start: dayjs(data.start).format(FORMAT_TIME.dateTimeH),
      end: dayjs(data.end).format(FORMAT_TIME.dateTimeH),
    };

    if (
      !dataParams.start ||
      !dataParams.end ||
      dataParams.start == "Invalid Date" ||
      dataParams.end == "Invalid Date"
    ) {
      Notification("warning", "Vui lòng chọn ngày");
      return;
    }
    try {
      const response = await accoutingFinancial
        .getExportTheKham(dataParams)
        .then((res) => {
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `Báo cáo thẻ khám.xlsx`;
          link.click();
          setLoadingPage(false);
          Notification("success", "Đã xuất file báo cáo");
        });
    } catch (error) {
      setLoadingPage(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };
  const handlePaginationChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setParams({ ...params, page: page, limit: pageSize });
  };
  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    showSizeChanger: true,
    pageSize: params.limit,
    onChange: handlePaginationChange,
  };
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  return (
    <Spin spinning={loadingPage}>
      <div className="report-pay-tab-container">
        <div className="container">
          <Form form={form} onFinish={handleOnFinish}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                <InputFields data={fields} />
              </Row>
              <Row justify={"end"} style={{ marginTop: "16px" }}>
                <Space>
                  <Button
                    icon={<ExcelSVG />}
                    className="custom-btn"
                    onClick={handelOnExport}
                  >
                    Xuất báo cáo
                  </Button>
                  <Button
                    icon={<Icon.eye />}
                    className="btn-sub"
                    htmlType="submit"
                  >
                    Xem thông tin
                  </Button>
                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={columns}
                        width={"400px"}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button
                      icon={<Icon.bars />}
                      className="btn-sub"
                      type="primary"
                    >
                      Cột hiển thị
                    </Button>
                  </Popover>
                </Space>
              </Row>
            </Space>
          </Form>
        </div>
        <div className="container">
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={data}
            loading={loading}
            columns={columns}
            scroll={{ x: 1200 }}
          />
        </div>
      </div>
    </Spin>
  );
};

export default TheKham;
